import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import Dropdown from 'flarum/common/components/Dropdown';
import Link from 'flarum/common/components/Link';

// Adds an "Espèces" dropdown to the header, right after champis-forum's
// 'home' (110) item in the same HeaderPrimary ItemList - and before
// champis-articles' 'articlesMenu' (90) and champis-forum's own
// 'forumsMenu' (85), matching champis.net's own top nav order (Accueil,
// Espèces, Articles, Forums). Reuses champis-forum's
// .ChampisForumsMenu-menu/-item classes (see forum.less) rather than
// duplicating that styling for what's currently just a couple of links -
// nothing about that CSS is forum-specific.
//
// The dropdown's own links are plain JSX children here, not a separate
// extensible ItemList of their own - champis-keys' /keys,
// champis-paintings' /paintings and champis-identifier's /identifier links
// are added directly rather than those extensions reaching in from
// outside. app.route() is a runtime
// lookup (populated by whichever extensions are enabled), not a
// build-time import, so this doesn't create an actual dependency on
// either one - same soft coupling as any app.route('discussion', ...)
// call elsewhere in this codebase.
export default function addSpeciesMenu() {
  extend(HeaderPrimary.prototype, 'items', function (items) {
    items.add('speciesMenu', m(Dropdown, {
      buttonClassName: "Button Button--link",
      menuClassName: "ChampisForumsMenu-menu",
      label: app.translator.trans('champis-species.forum.species_menu.label'),
      accessibleToggleLabel: app.translator.trans('champis-species.forum.species_menu.toggle_accessible_label')
    }, m(Link, {
      className: "ChampisForumsMenu-item",
      href: app.route('descriptions')
    }, app.translator.trans('champis-species.forum.species_menu.descriptions_link')), m(Link, {
      className: "ChampisForumsMenu-item",
      href: app.route('keys')
    }, app.translator.trans('champis-species.forum.species_menu.keys_link')), m(Link, {
      className: "ChampisForumsMenu-item",
      href: app.route('paintings')
    }, app.translator.trans('champis-species.forum.species_menu.paintings_link')), app.forum.attribute('canIdentifySpecies') && m(Link, {
      className: "ChampisForumsMenu-item",
      href: app.route('identifier')
    }, app.translator.trans('champis-identifier.forum.menu_link'))), 95);
  });
}